import{useRef as r,useEffect as t}from"react";function e(e){const n=r();return t((()=>{n.current=e}),[e]),n.current}export{e as default};
